<div class="modal-header">
    <h2 class="modal-title">{{ azione }} atto di finanziamento</h2>
    <button class="close" type="button" aria-label="Chiudi" (click)="activeModal.close()" tabindex="0">
        <app-toolkit-bl-icon icon="close-big"></app-toolkit-bl-icon>
    </button>
</div>
<div class="modal-body">
    <form class="form" role="form" [formGroup]="criteriaForm">
        <div class="form-row">
            <div class="form-group col-md-4">
                <label for="idLegge">Atto di finanziamento</label>
                <select class="form-control" formControlName="idLegge" id="idLegge">
                    <option [ngValue]="null">Seleziona un'opzione...</option>
                    <option *ngFor="let item of datalist.legge" [ngValue]="item.id">{{ item.descrizione }}</option>
                </select>
            </div>
            <div class="form-group col-md-4">
                <label for="importoFinanziatoEuro">Importo finanziato (€)</label>
                <input currencyMask [options]="{inputMode: natural,allowNegative: false, align: 'left', prefix: '€ ', thousands: '.', decimal: ',' }" class="form-control" id="importoFinanziatoEuro" formControlName="importoFinanziatoEuro" type="text">
            </div>
            <div class="form-group col-md-4">
                <label for="annoFinanziamento">Anno finanziamento</label>
                <input class="form-control" id="annoFinanziamento" formControlName="annoFinanziamento" type="number">
            </div>
            <div class="form-group col-md-4">
                <label for="programma">Programma</label>
                <input class="form-control" id="programma" formControlName="programma" type="text">
            </div>
            <div class="form-group col-md-4">
                <label for="annoFineLavori">Anno fine lavori</label>
                <input class="form-control" id="annoFineLavori" formControlName="annoFineLavori" type="number">
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" tabindex="0" (click)="activeModal.close()" class="btn btn-outline-primary">Chiudi</button>
    <button *ngIf="canEdit" type="button" tabindex="0" (click)="save()" class="btn btn-primary">Salva</button>
</div>
